import { useEffect, useState } from "react";
import { useProblem } from "../../contexts/problem-context";
import fetchWrapper from "../../utils/fetch";
import { Button, Input, Select, SelectItem, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Spinner } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Slider from "react-input-slider";
import { Accordion } from "@szhsin/react-accordion";
import { AccordionItem } from "../../components/accordion/accordion";
import { toast } from "react-toastify";

export default function UpdateAlternatives() {
  const [problemContext, problemDispatch] = useProblem();
  const [isLoading, setIsLoading] = useState(false);
  const [alternatives, setAlternatives] = useState({});
  const [numericalInputs, setNumericalInputs] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingAlternative, setEditingAlternative] = useState(null);
  const [tempAlternative, setTempAlternative] = useState(null);
  const [tempAlternativeName, setTempAlternativeName] = useState(""); // New state for alternative name
  const [crawlerPage, setCrawlerPage] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (problemContext.is_for_crawler) {
      const ni = {
        ...numericalInputs,
      };
      Object.keys(problemContext.varriables).map((varriableKey, varriableI) => {
        ni[varriableKey] = true;
      });
      setNumericalInputs(ni);
      // Removed: loadCrawlerAlternatives();
    } else {
      if (Object.keys(alternatives).length === 0) {
        if (Object.keys(problemContext.alternatives).length === 0) {
          const al = {};
          if (problemContext.problemType === "saw") {
            const ni = { ...numericalInputs };
            Object.keys(problemContext.varriables).forEach((varriableKey) => {
              ni[varriableKey] = false;
              al[varriableKey] = 2;
            });
            setNumericalInputs(ni);
          } else {
            Object.keys(problemContext.varriables).forEach((varriableKey) => {
              al[varriableKey] = problemContext.varriables[varriableKey][0];
            });
          }
          setAlternatives((v) => ({
            ...v,
            "گزینه‌ی تستی": al,
          }));
        } else {
          const ni = { ...numericalInputs };
          Object.keys(problemContext.varriables).forEach((varriableKey) => {
            ni[varriableKey] = problemContext.weights[varriableKey]
              ? problemContext.weights[varriableKey][2]
              : false;
          });
          // Sync alternatives with criteria in case some rates have been deleted
          const als = { ...problemContext.alternatives };
          Object.keys(problemContext.varriables).forEach((varriableKey) => {
            Object.keys(problemContext.alternatives).forEach((alternativeKey) => {
              let value =
                problemContext.alternatives[alternativeKey][varriableKey] ??
                undefined;
              if (value === undefined) {
                als[alternativeKey][varriableKey] =
                  problemContext.problemType === "saw"
                    ? 2
                    : problemContext.varriables[varriableKey][0];
                return;
              } else {
                if (problemContext.problemType !== "saw") {
                  if (!problemContext.varriables[varriableKey].includes(value)) {
                    als[alternativeKey][varriableKey] =
                      problemContext.varriables[varriableKey][0];
                  }
                }
              }
              Object.keys(problemContext.alternatives[alternativeKey]).forEach((alternativeVarriable) => {
                if (!Object.keys(problemContext.varriables).includes(alternativeVarriable)) {
                  delete als[alternativeKey][alternativeVarriable];
                }
              });
            });
          });
          setNumericalInputs(ni);
          setAlternatives(als);
        }
      } else {
        const als = { ...alternatives };
        Object.keys(als).forEach((alternativeKey) => {
          Object.keys(problemContext.varriables).forEach((varriableKey) => {
            if (als[alternativeKey][varriableKey] === undefined) {
              if (problemContext.problemType === "saw") {
                als[alternativeKey][varriableKey] = 2;
              } else {
                als[alternativeKey][varriableKey] =
                  problemContext.varriables[varriableKey][0];
              }
            }
          });
          if (
            Object.keys(problemContext.varriables).length !==
            Object.keys(als[alternativeKey]).length
          ) {
            Object.keys(als[alternativeKey]).forEach((aVarriableKey) => {
              if (!Object.keys(problemContext.varriables).includes(aVarriableKey)) {
                delete als[alternativeKey][aVarriableKey];
              }
            });
          }
        });
        const ni = { ...numericalInputs };
        Object.keys(problemContext.varriables).forEach((varriableKey) => {
          ni[varriableKey] = false;
        });
        setNumericalInputs(ni);
        setAlternatives(als);
      }
    }
    /* eslint-disable */
  }, [
    setAlternatives,
    problemContext.varriables,
    problemContext.weights,
    problemContext.is_for_crawler,
  ]);
  /* eslint-enable */

  // Only call loadCrawlerAlternatives on mount or when crawlerPage changes
  useEffect(() => {
    if (problemContext.is_for_crawler) {
      loadCrawlerAlternatives();
    }
    // eslint-disable-next-line
  }, [crawlerPage, problemContext.uid]);

  const handleSubmit = () => {
    setIsLoading(true);
    let allDefined = true;
    Object.keys(alternatives).forEach((alternativeKey) => {
      Object.keys(problemContext.varriables).forEach((varriableKey) => {
        if (
          alternatives[alternativeKey][varriableKey] === undefined ||
          alternatives[alternativeKey][varriableKey] === null ||
          alternatives[alternativeKey][varriableKey] === ""
        ) {
          allDefined = false;
        }
      });
    });
    if (!allDefined) {
      toast.error("باید تمامی‌ شاخص‌های همه‌ی گزینه‌ها را مشخص کنید.");
      setIsLoading(false);
      return;
    }
    const ws = [...problemContext.weights];
    if (problemContext.problemType === "saw") {
      Object.keys(problemContext.varriables).forEach((varriableKey, varriableI) => {
        ws[varriableI][2] = numericalInputs[varriableKey];
      });
    }
    fetchWrapper
      .post("/set/problem/alternatives", {
        problem_uid: problemContext.uid,
        alternatives: alternatives,
        weights: ws,
        copy_answers_from:
          problemContext.copyAnswersFromTemplate &&
          !problemContext.dirty_varriables &&
          problemContext.template_id
            ? problemContext.template_id
            : null,
      })
      .then((data) => {
        problemDispatch({
          type: "update alternatives",
          payload: {
            alternatives: alternatives,
            weights: ws,
          },
        });
        toast.success("گزینه‌ها با موفقیت ذخیره شدند");
        if (problemContext.problemType === "saw") {
          navigate(`/problem/result?problem_id=${problemContext.uid}`);
        } else {
          if (
            problemContext.copyAnswersFromTemplate &&
            !problemContext.dirty_varriables &&
            problemContext.template_id &&
            data.can_copy_answers
          ) {
            navigate(`/problem/result?problem_id=${problemContext.uid}`);
          } else {
            navigate("/problem/answer");
          }
        }
      })
      .catch((err) => {
        toast.error(err);
        setIsLoading(false);
      });
  };

  const loadCrawlerAlternatives = () => {
    setIsLoading(true);
    if (crawlerPage > 3) {
      toast.error("امکان دریافت موارد بیشتر وجود ندارد.");
      setIsLoading(false);
      return;
    }
    fetchWrapper
      .post("/crawler/load-alternatives", {
        problem_uid: problemContext.uid,
        page: crawlerPage,
        price_from: problemContext.crawler_start_price,
        price_to: problemContext.crawler_end_price,
        template_category: problemContext.template_category || "phone", // send as template_category
      })
      .then((data) => {
        // Fix: check for object keys, not array length
        if (!data.alternatives || Object.keys(data.alternatives).length === 0) {
          toast.error("گزینه‌های بیشتری پیدا نشد.");
        } else {
          setAlternatives((als) => ({
            ...als,
            ...data.alternatives,
          }));
          // If variables are present (for laptops), update problemContext.varriables
          if (data.variables) {
            problemDispatch({
              type: "load problem",
              payload: {
                ...problemContext,
                varriables: data.variables,
              },
            });
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        alert(JSON.stringify(err));
        setIsLoading(false);
      });
};

  const handleOpenModal = (alternative = null) => {
    if (alternative) {
      setEditingAlternative(alternative);
      setTempAlternativeName(alternative); // Set the current alternative name for editing
      setTempAlternative({ ...alternatives[alternative] });
    } else {
      setEditingAlternative(null);
      setTempAlternativeName(""); // New alternative name is empty by default
      const newAlternative = {};
      if (problemContext.problemType === "saw") {
        Object.keys(problemContext.varriables).forEach((varriableKey) => {
          newAlternative[varriableKey] = 2;
        });
      } else {
        Object.keys(problemContext.varriables).forEach((varriableKey) => {
          newAlternative[varriableKey] = problemContext.varriables[varriableKey][0];
        });
      }
      setTempAlternative(newAlternative);
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditingAlternative(null);
    setTempAlternative(null);
    setTempAlternativeName("");
  };

  const handleSaveAlternative = () => {
    if (!tempAlternativeName.trim()) {
      toast.error("نام گزینه نمی‌تواند خالی باشد");
      return;
    }
    if (!editingAlternative) {
      // Add new alternative using the name entered by the user
      const newName = tempAlternativeName.trim();
      setAlternatives((prev) => ({
        ...prev,
        [newName]: tempAlternative,
      }));
      toast.success("گزینه جدید با موفقیت اضافه شد");
    } else {
      // Editing existing alternative: remove the old key and add the new one with the updated name
      setAlternatives((prev) => {
        const newAlternatives = { ...prev };
        delete newAlternatives[editingAlternative];
        return {
          ...newAlternatives,
          [tempAlternativeName.trim()]: tempAlternative,
        };
      });
      toast.success("تغییرات با موفقیت ذخیره شد");
    }
    handleCloseModal();
  };

  const handleTempChange = (varriableKey, value) => {
    setTempAlternative((prev) => ({
      ...prev,
      [varriableKey]:
        problemContext.problemType === "saw" ? value : value.target.value,
    }));
  };

  const removeAlternative = (alternativeName) => {
    if (Object.keys(alternatives).length === 1) {
      toast.error("حداقل یک گزینه الزامی‌ست");
      return;
    }
    const as = { ...alternatives };
    delete as[alternativeName];
    setAlternatives(as);
    toast.success("گزینه با موفقیت حذف شد");
  };

  const toggleNumericalInput = (varriableKey, value) => {
    const ni = { ...numericalInputs };
    if (value) {
      Object.keys(alternatives).forEach((alternativeKey) => {
        changeAlternativeVarriableRate(alternativeKey, varriableKey, 2);
      });
    } else {
      Object.keys(alternatives).forEach((alternativeKey) => {
        changeAlternativeVarriableRate(alternativeKey, varriableKey, 2);
      });
    }
    ni[varriableKey] = value;
    setNumericalInputs(ni);
  };

  const changeAlternativeVarriableRate = (alternativeKey, varriableKey, e) => {
    setIsLoading(true);
    const als = { ...alternatives };
    als[alternativeKey][varriableKey] =
      problemContext.problemType === "saw" ? e : e.target.value;
    setAlternatives(als);
    setIsLoading(false);
  };

  return (
    <div>
      {/* Loading indicator for crawler */}
      {problemContext.is_for_crawler && isLoading && (
        <div className="flex flex-col items-center justify-center my-8">
          <span className="mb-2 text-lg font-semibold text-gray-700">درحال بارگذاری گزینه های پیشنهادی</span>
          <Spinner size="lg" color="primary" />
        </div>
      )}
      {/* Only render alternatives when not loading in crawler mode */}
      {(!problemContext.is_for_crawler || !isLoading) && (
        <>
          <h3 className="text-center text-3xl font-bold mb-8">
            {problemContext.problemName}
          </h3>

          <div className="space-y-4">
            <AnimatePresence>
              {Object.keys(alternatives).map((key) => (
                <motion.div
                  key={key}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{
                    opacity: [1, 0],
                    scale: [1, 1.2, 0],
                    rotate: [0, 5, -5, 0],
                    transition: {
                      duration: 0.4,
                      times: [0, 0.2, 1],
                      ease: "easeOut",
                    },
                  }}
                  transition={{ duration: 0.2 }}
                  className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-lg font-medium">{key}</span>
                      <Button
                        size="sm"
                        variant="light"
                        onPress={() => handleOpenModal(key)}
                        className="text-gray-500"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-5 h-5"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                          />
                        </svg>
                      </Button>
                    </div>
                    <Button
                      color="danger"
                      variant="light"
                      onPress={() => removeAlternative(key)}
                      isDisabled={Object.keys(alternatives).length === 1}
                    >
                      حذف
                    </Button>
                  </div>
                  {/* ...rest of the alternative rendering... */}
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
        </>
      )}

      <motion.div
        className="w-full border-2 border-dashed border-gray-300 rounded-lg p-6 hover:border-primary-500 transition-colors cursor-pointer"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={() => handleOpenModal()}
      >
        <div className="flex flex-col items-center justify-center gap-2">
          <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 text-primary-500"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
          </div>
          <div className="text-center">
            <p className="text-lg font-medium text-gray-900">افزودن گزینه جدید</p>
            <p className="text-sm text-gray-500 mt-1">برای اضافه کردن گزینه جدید کلیک کنید</p>
          </div>
        </div>
      </motion.div>

      <Modal isOpen={isModalOpen} onClose={handleCloseModal} size="2xl" scrollBehavior="inside">
        <ModalContent>
          <ModalHeader>
            {editingAlternative ? "ویرایش گزینه" : "افزودن گزینه جدید"}
          </ModalHeader>
          <ModalBody>
            <div className="space-y-6 py-4">
              {/* New input for alternative name */}
              <div className="mb-4">
                <Input
                  type="text"
                  label="نام گزینه"
                  value={tempAlternativeName}
                  onChange={(e) => setTempAlternativeName(e.target.value)}
                  placeholder="نام گزینه را وارد کنید"
                  isRequired
                />
              </div>
              {tempAlternative &&
                Object.keys(problemContext.varriables).map((varriableKey) => (
                  <div key={varriableKey} className="space-y-2">
                    <h3 className="font-medium">{varriableKey}</h3>
                    {problemContext.problemType === "saw" ? (
                      <div className="space-y-2">
                        {numericalInputs[varriableKey] ? (
                          <Input
                            type="number"
                            label="مقدار معیار"
                            value={tempAlternative[varriableKey]}
                            onValueChange={(value) => handleTempChange(varriableKey, value)}
                            labelPlacement="inside"
                            isRequired
                          />
                        ) : (
                          <>
                            <div className="flex justify-between items-center">
                              <span className="text-sm text-gray-500">مقدار: {tempAlternative[varriableKey]}</span>
                              <span className="text-sm text-gray-500">حداکثر: 5</span>
                            </div>
                            <Slider
                              styles={{
                                track: { width: "100%" },
                                active: { left: 0 },
                              }}
                              axis="x"
                              x={tempAlternative[varriableKey]}
                              onChange={({ x }) => handleTempChange(varriableKey, x)}
                              xmax={5}
                              xstep={1}
                            />
                          </>
                        )}
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            checked={numericalInputs[varriableKey]}
                            onChange={(e) => toggleNumericalInput(varriableKey, e.target.checked)}
                            id={`numerical-${varriableKey}`}
                          />
                          <label htmlFor={`numerical-${varriableKey}`}>معیار عددی</label>
                        </div>
                      </div>
                    ) : (
                      <Select
                        isRequired
                        placeholder="انتخاب یک حالت"
                        selectedKeys={[tempAlternative[varriableKey]]}
                        onChange={(e) => handleTempChange(varriableKey, e)}
                      >
                        {problemContext.varriables[varriableKey].map((rate) => (
                          <SelectItem key={rate} value={rate}>
                            {rate}
                          </SelectItem>
                        ))}
                      </Select>
                    )}
                  </div>
                ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" variant="light" onPress={handleCloseModal}>
              لغو
            </Button>
            <Button color="primary" onPress={handleSaveAlternative}>
              {editingAlternative ? "ذخیره تغییرات" : "افزودن گزینه"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Button
        className="w-full mt-8"
        color="secondary"
        variant="solid"
        onClick={handleSubmit}
        isLoading={isLoading}
        isDisabled={isLoading}
      >
        ثبت گزینه‌ها و ادامه
      </Button>
      {problemContext.is_for_crawler && crawlerPage < 3 && (
        <Button
          className="w-full mt-4"
          color="primary"
          variant="solid"
          onClick={() => setCrawlerPage((page) => page + 1)}
          isLoading={isLoading}
          isDisabled={isLoading}
        >
          بارگذاری بیشتر
        </Button>
      )}
    </div>
  );
}
